import { useSelector } from 'react-redux';
import { SessionStateI } from './sessionSlice';

interface RootStateWithSessionI {
  session: SessionStateI;
}

const useActiveSession = (): {
  isLogged: boolean;
  isChecked: boolean;
} => {
  const { isLogged, isChecked } = useSelector(
    (state: RootStateWithSessionI) => ({
      isLogged: state.session.logged,
      isChecked: state.session.checked,
    })
  );

  return {
    isChecked,
    isLogged,
  };
};

export default useActiveSession;
